import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { images } from "../assets";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: t("bufferZones.bufferZones", { ns: "dialogs" }),
        icon: "tools_buffer",
      },
      applyText: t("actions.build", { ns: "common" }),
      help: {
        openAtFirst: false,
        hintsBlock: {
          title: t("bufferZones.hintBlockTitle", { ns: "dialogs" }),
          hints: [
            {
              label: t("bufferZones.sourceObject", { ns: "dialogs" }),
              img: images.initialObject,
            },
            {
              icon: "plus",
            },
            {
              label: t("bufferZones.setDistance", { ns: "dialogs" }),
              img: images.distanceToObject,
            },
            {
              icon: "pause",
            },
            {
              label: t("bufferZones.zoneRadius", { ns: "dialogs" }),
              img: images.result,
            },
          ],
        },
      },
    }),
    [t],
  );
};
